interface IShouldShowPlatformLogomarkProps {
  // NOTE: NSAI-6427 — the build half of the rule: the square NodeShift mark is
  // NodeShift's own, so no other flavor's build may render it, whatever the
  // organization on screen has configured. An INPUT rather than a call to
  // `isNodeShiftFlavor()` inside this helper, for the same reason
  // `shouldShowAuthIllustration` takes `isFlavorGated`: `VITE_PLATFORM_FLAVOR`
  // is baked into the bundle at build time and CI builds one flavor, so a
  // helper that read it itself would put half this truth table beyond anything
  // CI can execute.
  isNodeShiftFlavor: boolean;
  // NOTE: The branding flags all start false, which is indistinguishable from a
  // confirmed "this organization configured nothing" until the lookup answers.
  // Painting on the unresolved state is the flash this guard exists to prevent
  // — and here it would flash NodeShift's mark at a white-label customer.
  isBrandingResolved: boolean;
  // NOTE: `hasOwnOrgBranding` from `@frontend-shared/utils` — a stylesheet, an
  // uploaded logo or a product name. Deliberately NOT `hasCustomBranding` from
  // the theme provider, which only knows about the stylesheet: reading that one
  // is what showed the platform mark to organizations that had uploaded their
  // logo and nothing else.
  hasOwnBranding: boolean;
}

// NOTE: NSAI-6427 — who may see the square NodeShift mark in the empty chat.
// Per the product decision (Slack, 23 Sep 2026): NodeShift, and nobody else.
//
// The three inputs are the three ways a screen stops being NodeShift's: the
// build belongs to another product, the organization brought branding of its
// own, or we do not know yet. Only when none of them holds is the mark correct;
// every other row falls back to `Logo`, which resolves the organization's own
// uploaded logo and, failing that, the running flavor's wordmark.
export const shouldShowPlatformLogomark = ({
  isNodeShiftFlavor,
  isBrandingResolved,
  hasOwnBranding,
}: IShouldShowPlatformLogomarkProps): boolean => {
  return isNodeShiftFlavor && isBrandingResolved && !hasOwnBranding;
};
